<template>
    <div id="help">
        <p>{{title}}</p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            title:'使用帮助'
        }
    }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mine/Help.vue